import React, { useState } from "react"
import { Subscription } from "react-apollo"
import { toast } from "react-toastify"
import Cookies from "universal-cookie"
import { displayTime, userInfo } from "utils"
import { chatMessageNotification } from "gql/subscriptions"
import MessageNotification from "./MessageNotification"
import NotificationContext from "../NotificationContext"
import { PHOTO, FILE } from "../messageTypes"

const withPushNotification = Component => props => {
  const [subscribe, setSubscribe] = useState(true)
  const [currentMsgId, setCurrentMsgId] = useState("")

  const notify = data => {
    const { chatMessageNotification } = data
    if (
      !toast.isActive(chatMessageNotification.chatMessage.id) &&
      currentMsgId !== chatMessageNotification.chatMessage.id
    ) {
      toast(
        <MessageNotification
          sender={chatMessageNotification.chatMessage.sender.name}
          msgText={msgContent(data)}
          chatRoomId={chatMessageNotification.chatRoom.id}
          userInfo={userInfo()}
        />,
        {
          toastId: chatMessageNotification.chatMessage.id,
          onClick: () => {
            props.history.push(
              `/message/${chatMessageNotification.chatRoom.id}/${
                chatMessageNotification.chatMessage.sender.name
              }`
            )
          }
        }
      )

      saveUnreadsCookie(data)
      setCurrentMsgId(chatMessageNotification.chatMessage.id)
    }
  }

  const msgContent = data => {
    const {
      chatMessageNotification: { chatMessage }
    } = data

    if (chatMessage.type === FILE) {
      return `${chatMessage.sender.name}向您傳送了檔案`
    }

    if (chatMessage.type === PHOTO) {
      return `${chatMessage.sender.name}向您傳送了圖片`
    }

    return chatMessage.content
  }

  const saveUnreadsCookie = data => {
    const cookies = new Cookies()
    const unreads = cookies.get("unreads")
    const { chatMessageNotification } = data

    if (!unreads) {
      cookies.set("unreads", "1", { path: "/" })
      cookies.set(
        "unreadMessages",
        [
          {
            chatRoomId: chatMessageNotification.chatRoom.id,
            name: chatMessageNotification.chatMessage.sender.name,
            content: msgContent(data),
            createdAt: displayTime(
              chatMessageNotification.chatMessage.createdAt
            )
          }
        ],
        { path: "/" }
      )
    } else {
      cookies.set("unreads", parseInt(unreads, 10) + 1, { path: "/" })

      const messages = cookies.get("unreadMessages")
      cookies.set(
        "unreadMessages",
        [
          {
            name: chatMessageNotification.chatMessage.sender.name,
            content: msgContent(data),
            createdAt: displayTime(
              chatMessageNotification.chatMessage.createdAt
            )
          },
          ...messages
        ],
        { path: "/" }
      )
    }
  }

  return (
    <NotificationContext.Provider value={{ setSubscribe }}>
      {subscribe === true && (
        <Subscription subscription={chatMessageNotification}>
          {({ data }) => {
            subscribe && data && notify(data)
            !subscribe &&
              data &&
              setCurrentMsgId(data.chatMessageNotification.chatMessage.id)

            return null
          }}
        </Subscription>
      )}
      <Component {...props} />
    </NotificationContext.Provider>
  )
}

export default withPushNotification
